import _ from 'lodash'
import {layoutUtils} from '@wix/santa-core-utils'

const getLayoutMechanism = () => 'mesh'

export default _.assign({}, layoutUtils, {getLayoutMechanism}) as typeof layoutUtils
